import React from 'react';

import SettingsField from 'ui-library/SettingsField';

interface SchemaDescriptionInputProps {
  value: string | null;
  onChange: (value: string) => void;
  isWritable: boolean;
  isBeingCreated: boolean;
}

function SchemaDescriptionInput(props: SchemaDescriptionInputProps): JSX.Element {
  return (
    <SettingsField
      dataTestAttrs={{component: 'SchemaDescriptionInput', element: 'root'}}
      isBeingCreated={props.isBeingCreated}
      isMultiline={true}
      isRequired={false}
      isWritable={props.isWritable}
      label="Schema Description"
      name="schemaDescription"
      onChange={props.onChange}
      urlAware={true}
      emptyValueAllowed={true}
      textPlaceholder="Enter a description for the schema."
      value={props.value ?? ''}
      withLabelBottomMargin={true}
    />
  );
}

export default SchemaDescriptionInput;
